export enum FileType {

  SERVICE_IMAGE = 'SERVICE_IMAGE',
  PROJECT_ATTACHMENTS = 'PROJECT_ATTACHMENTS',
  PROJECT_FUNDING_ATTACHMENT = 'PROJECT_FUNDING_ATTACHMENT',
  PROJECT_UPDATE_ATTACHMENT = 'PROJECT_UPDATE_ATTACHMENT',
  PROJECT_ACTION_ATTACHMENT = 'PROJECT_ACTION_ATTACHMENT',
  STORY_IMAGE = 'STORY_IMAGE',
  PROJECT_REPORT_PRACTICES = 'PROJECT_REPORT_PRACTICES',
  PROJECT_REPORT_FINANCIAL = 'PROJECT_REPORT_FINANCIAL',
  PROJECT_APPROVED_BY_WOSM_ATTACHMENT = 'PROJECT_APPROVED_BY_WOSM_ATTACHMENT',
  ORGANIZATION = 'ORGANIZATION',
  SUMMARY_NOTE = 'SUMMARY_NOTE',
  ANNUAL_REPORT = 'ANNUAL_REPORT',
  ANNUAL_FINANCIAL_STATEMENT = 'ANNUAL_FINANCIAL_STATEMENT',
  SAFE_FROM_HARM_POLICY = 'SAFE_FROM_HARM_POLICY',
  SAFE_FROM_HARM_REPORTING = 'SAFE_FROM_HARM_REPORTING'
}
